const AUTH_ACCESS_TOKEN_ENDPOINT = '/users/auth/login/';
const AUTH_REVOKE_ACCESS_TOKEN_ENDPOINT = '/users/auth/logout/';

const AUTH_SIGNUP_ENDPOINT = '/users/auth/signup/';

const AUTH_GOOGLE_OAUTH_TOKEN_ENDPOINT = '/users/auth/callback/google/';

const AUTH_SIGNUP_VERIFY_CODE_ENDPOINT = '/users/auth/callback/verify_code/';

const USER_PROFILE_ENDPOINT = '/users/profile/';

const UPLOAD_MEDIA_ENDPOINT = '/media/upload/';

const ORGANIZATION_ENDPOINT = '/organization/';

const DELETE_MEDIA_FILE_ENDPOINT = '/media/delete/';

const SAVE_MEDIA_FILE_IMAGE_ENDPOINT = '/media/save_image/';

const DELETE_MEDIA_FILE_IMAGE_ENDPOINT = '/media/delete_image/';

const METRICS_ENDPOINT = '/metrics/';

const SETTINGS_ENDPOINT = '/organization/settings';

const GET_MEDIA_ENDPOINT = '/media/file/';

const FOLDER_SHARE_ENDPOINT = '/media/share';

export {
    AUTH_ACCESS_TOKEN_ENDPOINT,
    AUTH_REVOKE_ACCESS_TOKEN_ENDPOINT,
    AUTH_GOOGLE_OAUTH_TOKEN_ENDPOINT,
    AUTH_SIGNUP_ENDPOINT,
    USER_PROFILE_ENDPOINT,
    UPLOAD_MEDIA_ENDPOINT,
    ORGANIZATION_ENDPOINT,
    AUTH_SIGNUP_VERIFY_CODE_ENDPOINT,
    METRICS_ENDPOINT,
    DELETE_MEDIA_FILE_ENDPOINT,
    SAVE_MEDIA_FILE_IMAGE_ENDPOINT,
    DELETE_MEDIA_FILE_IMAGE_ENDPOINT,
    GET_MEDIA_ENDPOINT,
    SETTINGS_ENDPOINT,
    FOLDER_SHARE_ENDPOINT,
};
